import { render } from "./DataSourceIcon.vue?vue&type=template&id=d5400af4"
import script from "./DataSourceIcon.vue?vue&type=script&lang=js"
export * from "./DataSourceIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__